module.exports = {
      id: "pak-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#pak-flag",
      toString: function () {
        return this.url;
      }
    }